// WIP

import PropTypes from 'prop-types';
import classnames from 'classnames';
import React from 'react';

export default function Toggle({
  className,
  label,
  dataTestId,
  ...inputProps
}) {
  return (
    <label className={classnames('DSToggle', className)}>
      <input {...inputProps} type="checkbox" />
      <span data-test-id={dataTestId} className="DSToggle__slider" />
      {label && <span className="ml2">{label}</span>}
    </label>
  );
}

Toggle.propTypes = {
  className: PropTypes.string,
  label: PropTypes.string,
  dataTestId: PropTypes.string
};

Toggle.defaultProps = {
  className: null,
  label: null,
  dataTestId: null
};
